import { FilterListSMSIcon } from '@rsos/assets/icons';
import { LiveVideoButtonContainer } from '../../VideoTo911/LiveVideoButtonContainer';
import { AccordionContainer } from '../TF911.styles';
import TF911StartChatMessages from '../TF911StartChatMessages';
import {
  ChatAccordion,
  OFFSET_HEIGHT,
  StartChatContainer,
  StartChatButtonNext,
  ChatAccordionHeaderContainer,
} from './TF911StartChatAccordion.styles';

const TF911StartChatUnite = ({
  gpxFeature,
  handleDefaultStartClick,
  handleOnClickShowAccordion,
  isCreatingConversation,
  isForOverview,
  isVT911Enabled,
  onStartConversation,
  preconfiguredMessages,
  showPreconfiguredMessages,
}) => {
  return (
    <StartChatContainer>
      <AccordionContainer showBorder={showPreconfiguredMessages} width="100%">
        <ChatAccordion
          btnDisabled={isCreatingConversation}
          callback={handleOnClickShowAccordion}
          content={
            <TF911StartChatMessages
              isCreatingConversation={isCreatingConversation}
              preconfiguredMessages={preconfiguredMessages}
              onSendMessageClick={onStartConversation}
              isUniteEventPaneEnabled={true}
              isForOverview={isForOverview}
              gpxFeature={gpxFeature}
            />
          }
          header={
            <ChatAccordionHeaderContainer>
              {isVT911Enabled && (
                <LiveVideoButtonContainer
                  onStartConversation={onStartConversation}
                  isForOverview={isForOverview}
                />
              )}
              <StartChatButtonNext
                disabled={isCreatingConversation}
                isLoadingProp={isCreatingConversation}
                onClick={handleDefaultStartClick}
              >
                <FilterListSMSIcon width={12} height={12} />
                Start Chat
              </StartChatButtonNext>
            </ChatAccordionHeaderContainer>
          }
          headerPadding={isForOverview ? '0 16px' : '0 12px'}
          isOpened={showPreconfiguredMessages}
          height={isForOverview ? '100%' : `calc(100% - ${OFFSET_HEIGHT}px)`}
        />
      </AccordionContainer>
    </StartChatContainer>
  );
};

export default TF911StartChatUnite;
